var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file/search_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24984 1.66699C5.33782 1.66699 2.1665 4.83831 2.1665 8.75033C2.1665 12.6623 5.33782 15.8337 9.24984 15.8337C10.9056 15.8337 12.4286 15.2656 13.6347 14.3136L16.6783 17.3573C17.0038 17.6827 17.5314 17.6827 17.8568 17.3573C18.1823 17.0318 18.1823 16.5042 17.8568 16.1787L14.8132 13.1351C15.7651 11.9291 16.3332 10.406 16.3332 8.75033C16.3332 4.83831 13.1619 1.66699 9.24984 1.66699ZM3.83317 8.75033C3.83317 5.75878 6.2583 3.33366 9.24984 3.33366C12.2414 3.33366 14.6665 5.75878 14.6665 8.75033C14.6665 11.7419 12.2414 14.167 9.24984 14.167C6.2583 14.167 3.83317 11.7419 3.83317 8.75033Z",
    fill: "#797D80"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLine);
export default __webpack_public_path__ + "static/media/search_line.a38d015ea2a2602308b88b942af2b72c.svg";
export { ForwardRef as ReactComponent };